import * as Yup from 'yup'
import { StatusType } from '../constants/fieldValues.constant'
import moment from 'moment'
import { BusinessCardListRequest } from '@app/store/reducers/salaryCards/businessCardOrder.api'

export const orderFilterSchema: Yup.ObjectSchema<BusinessCardListRequest> =
  Yup.object().shape({
    startDate: Yup.string()
      .required('orders.salaryCardOrder.restrictionTexts.startDate')
      .test(
        'is-before-startDate',
        'orders.salaryCardOrder.restrictionTexts.isBeforeStartDate',
        function (value) {
          const { endDate } = this.parent
          if (!endDate || !value) {
            return true
          }

          const start = moment(value, 'DD.MM.YYYY', true)
          const end = moment(endDate, 'DD.MM.YYYY', true)

          return start.isSameOrBefore(end)
        }
      ),
    endDate: Yup.string()
      .required('orders.salaryCardOrder.restrictionTexts.endDate')
      .test(
        'is-after-startDate',
        'orders.salaryCardOrder.restrictionTexts.isAfterStartDate',
        function (value) {
          const { startDate } = this.parent
          if (!startDate || !value) {
            return true
          }

          const start = moment(startDate, 'DD.MM.YYYY', true)
          const end = moment(value, 'DD.MM.YYYY', true)

          return end.isSameOrAfter(start)
        }
      ),
    status: Yup.string()
      .oneOf(
        Object.values(StatusType),
        'orders.salaryCardOrder.restrictionTexts.status'
      )
      .required('orders.salaryCardOrder.restrictionTexts.requiredFields'),
    searchText: Yup.string().optional(),
  })
